import { fetcher } from "helpers/fetcher";

import { TGetPipelineStatusListReq, TGetPipelineStatusListRes } from "./types";
import { LanguageType } from "types/index";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getPipelineStatusList = async (
  payload: TGetPipelineStatusListReq,
  language?: LanguageType
) => {
  return await fetcher<TGetPipelineStatusListRes, any>(
    ENDPOINT.MANAGEMENT.GET_USERS_PIPELINE_STATUS_LIST,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.MANAGEMENT.GET_USERS_PIPELINE_STATUS_LIST.version,
        [API_HEADER.BU_ID]: payload.idBu,
        [API_HEADER.LANGUAGE]: language,
      },
      urlData: { pipelineSlug: payload?.pipelineSlug },
    }
  );
};

export const queryGetPipelineStatusList = async (
  payload: TGetPipelineStatusListReq,
  language: LanguageType = "en"
) => {
  return (await getPipelineStatusList(payload, language)).data;
};

queryGetPipelineStatusList._key = (
  payload?: TGetPipelineStatusListReq,
  language: LanguageType = "en"
) => [
  ENDPOINT.MANAGEMENT.GET_USERS_PIPELINE_STATUS_LIST.url,
  payload,
  language,
];
